import React, { useState, useEffect } from 'react'
import './css/ProductDetails.css'
import NavbarForProductList from './NavbarProduct';
const ProductDetails = () => {
    const [productData, setProductData] = useState({});
    const showDetails = async () => {
        const req = await fetch('https://jivichem.herokuapp.com/api/v1/product/getDetails', {
            headers: {
                'x-access-token': localStorage.getItem('token')
            },
        })

        const data = await req.json()
        if (data.status === 'ok') {
            setProductData(data.product)
        } else {
            alert(data.error)
        }
    }
    useEffect(()=>{
        showDetails();
    },[])

    return (
        <>
            <NavbarForProductList/>
            <table className="center">
                <thead>
                    <tr>
                        <th>
                            <font color="midnightblue">S. No.</font>
                        </th>
                        <th>
                            <font color="midnightblue">Name of the Product</font>
                        </th>
                        <th>
                            <font color="midnightblue">CAS Number</font>
                        </th>
                    </tr>
                </thead>
                <tbody id="myTable">

                    <tr>
                        <td>1</td>
                        <td>{productData.name}</td>
                        <td>{productData.cas}</td>
                    </tr>

                </tbody>
            </table>
        </>
    )
}
export default ProductDetails;